import { c as _c } from "react/compiler-runtime";
import { LoaderIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { cn } from '@/utils/cn';
type SpinnerProps = React.ComponentProps<'svg'>;
export function Spinner(props) {
  const $ = _c(11);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  const t = useTranslations();
  let t0;
  if ($[3] !== t) {
    t0 = t("common.aria-labels.loading");
    $[3] = t;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn("size-4 animate-spin", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== rest || $[8] !== t0 || $[9] !== t1) {
    t2 = <LoaderIcon role="status" aria-label={t0} className={t1} {...rest} />;
    $[7] = rest;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}